import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback, useState } from "react";
import Snowfall from "react-snowfall";
import { KeyCombination, useKeyboardShortcut } from "@advosys/component-react";
import { hasValue, now } from "@advosys/component-react-utils";
const snowflake = document.createElement("img");
snowflake.src = "/snowflake.png";
const visibleMonths = [12];
const getIntialVisible = () => {
    const localStorageValue = localStorage.getItem("ee");
    if (hasValue(localStorageValue)) {
        return localStorageValue === "true";
    }
    return visibleMonths.includes(now().getMonth());
};
export const EasterEgg = () => {
    const [visible, setVisible] = useState(getIntialVisible());
    const toggleVisible = useCallback(() => {
        setVisible(prev => {
            const newValue = !prev;
            localStorage.setItem("ee", newValue ? "true" : "false");
            return newValue;
        });
    }, []);
    useKeyboardShortcut(KeyCombination.EasterEgg, toggleVisible);
    if (!visible)
        return null;
    return _jsx(Snowfall, { speed: [0.5, 2], images: [snowflake], radius: [2, 8] });
};
